import React from 'react';
import { FaMapMarkerAlt, FaTimes } from 'react-icons/fa';
import '../styles/components/selected-points-display.css';

const SelectedPointsDisplay = ({
  measurementPoints,
  onRemovePoint,
  measurementMode,
  onClearAllPoints
}) => {
  if (!measurementPoints || measurementPoints.length === 0) {
    return null;
  }

  return (
    <div className="selected-points-panel">
      <div className="selected-points-header">
        <h3 className="selected-points-title">
          <FaMapMarkerAlt className="selected-points-icon" />
          Selected Points ({measurementPoints.length})
        </h3>
        <button
          className="selected-points-clear"
          onClick={onClearAllPoints}
          title="Clear all points"
        >
          <FaTimes />
        </button>
      </div>

      <div className="selected-points-mode">
        Mode: <span className="selected-points-mode-value">{measurementMode || 'None'}</span>
      </div>

      <div className="selected-points-list">
        {measurementPoints.map((point, index) => (
          <div key={index} className="selected-point-item">
            <div className="selected-point-header">
              <span className="selected-point-number">Point {index + 1}</span>
              {onRemovePoint && (
                <button
                  className="selected-point-remove"
                  onClick={() => onRemovePoint(index)}
                  title="Remove this point"
                >
                  <FaTimes />
                </button>
              )}
            </div>
            <div className="selected-point-coordinates">
              <div className="coordinate-row">
                <span className="coordinate-label">X:</span>
                <span className="coordinate-value">{point[0].toFixed(3)}</span>
              </div>
              <div className="coordinate-row">
                <span className="coordinate-label">Y:</span>
                <span className="coordinate-value">{point[1].toFixed(3)}</span>
              </div>
              <div className="coordinate-row">
                <span className="coordinate-label">Z:</span>
                <span className="coordinate-value">{point[2].toFixed(3)}</span>
              </div>
            </div>
            {index > 0 && (
              <div className="point-distance">
                Distance from previous: {
                  Math.sqrt(
                    Math.pow(point[0] - measurementPoints[index - 1][0], 2) +
                    Math.pow(point[1] - measurementPoints[index - 1][1], 2) +
                    Math.pow(point[2] - measurementPoints[index - 1][2], 2)
                  ).toFixed(3)
                } m
              </div>
            )}
          </div>
        ))}
      </div>

      {measurementMode === 'distance' && measurementPoints.length === 1 && (
        <div className="selected-points-hint">
          Select one more point to complete distance measurement
        </div>
      )}

      {measurementMode === 'area' && measurementPoints.length < 3 && (
        <div className="selected-points-hint">
          Select at least {3 - measurementPoints.length} more point(s) to create an area
        </div>
      )}

      {measurementMode === 'volume' && measurementPoints.length < 3 && (
        <div className="selected-points-hint">
          Select at least {3 - measurementPoints.length} more point(s) to create a volume base
        </div>
      )}
    </div>
  );
};

export default SelectedPointsDisplay;